<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button
        v-if="Permission.indexOf(230) !== -1"
        type="primary"
        size="mini"
        @click="addProject"
        >{{ $t("lang.Button.Add") }}</el-button
      >
    </div>
    <el-table
      class="myTable"
      height="650"
      border
      :header-cell-style="{ background: '#e4f1ff' }"
      :data="projectList"
      style="overflow-y: scroll"
      size="mini"
      ref="projectTable"
      row-key="groupId"
      :load="load"
      @selection-change="selectChange"
      @sort-change="sortChange"
      :tree-props="{ children: 'childrens', hasChildren: 'groupId' }"
      :lazy="true"
      id="out-table"
    >
      <el-table-column
        type="selection"
        min-width="40"
        reserve-selection
        :selectable="checkboxInit"
      ></el-table-column>
      <el-table-column
        :label="`${$t('lang.projectList.name')}`"
        sortable="custom"
        prop="groupName"
      >
        <template slot-scope="scope">
          <el-input
            v-model="seek.groupName"
            v-if="scope.$index === 0"
            size="mini"
            clearable
          ></el-input>
          <span class="table-font" v-else>{{ scope.row.groupName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="`${$t('lang.projectList.projectType')}`"
        prop="groupMonitorType"
      >
        <template slot-scope="scope">
          <el-select
            size="mini"
            v-if="scope.$index === 0"
            v-model="seek.selectType"
            clearable
          >
            <el-option
              v-for="item in typeOptions"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
          <span class="table-font" v-else>{{ scope.row.groupName }}</span>
        </template>
      </el-table-column>

      <el-table-column
        :label="`${$t('lang.projectList.BelogingCustomer')}`"
        sortable="custom"
        prop="cname"
      >
        <template slot-scope="scope">
          <el-input
            v-model="seek.cname"
            v-if="scope.$index === 0"
            size="mini"
            clearable
          ></el-input>
          <span class="table-font" v-else>{{ scope.row.cname }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="`${$t('lang.projectList.creator')}`"
        sortable="custom"
        prop="groupCreateName"
      >
        <template slot-scope="scope">
          <el-input
            v-model="seek.groupCreateName"
            v-if="scope.$index === 0"
            size="mini"
            clearable
          ></el-input>
          <span class="table-font" v-else>{{ scope.row.groupCreateName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="`${$t('lang.projectList.createTime')}`"
        sortable="custom"
        prop="groupCreate"
      >
        <template slot-scope="scope">
          <span class="table-font" v-if="scope.$index !== 0">
            {{ scope.row.groupCreate | formateDate }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :label="`${$t('lang.TableComponent.operating')}`"
        align="center"
        width="200px"
      >
        <template slot-scope="scope">
          <div v-if="scope.$index !== 0">
            <el-button
              type="primary"
              icon="icon-chaxun"
              circle
              @click="goToDevices(scope.row)"
            ></el-button>
            <el-button
              v-if="Permission.indexOf(236) !== -1"
              type="primary"
              icon="el-icon-edit"
              circle
              @click="editProject(scope.row)"
            ></el-button>
            <el-button
              v-if="Permission.indexOf(231) !== -1"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="deleteProject(scope.row)"
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
    <!-- 添加编辑 -->
    <cont-dialog
      ref="contDialog"
      @updateList="queryKeyword"
      @reFleshTable="reFleshTable"
    ></cont-dialog>
  </div>
</template>
<script>
import pagination from "@/components/pagination";
import { PublicComponent } from "@/mixins/common.js";
import {
  getFirstGroup,
  getSecondGroup,
  addProjectGroup,
  editProjectGroup,
  deleteProjectGroup,
  queryGroup,
} from "@/api/cloudMonitor/projectGroup";
import contDialog from "./components/contDialog";
import moment from "moment";
import { getPermission } from "@/cookie/cookie";
export default {
  mixins: [PublicComponent],
  components: {
    pagination,
    contDialog,
  },
  data() {
    return {
      typeObj: {
        0: this.$t("lang.projectList.generictype"),
        1: "中建三局",
      },
      typeOptions: [
        {
          label: this.$t("lang.projectList.generictype"),
          value: "0",
        },
        {
          label: "中建三局",
          value: "1",
        },
      ],
      selectType: "", //默认为空（即全部）
      projectList: [],
      seek: {
        groupName: "",
        cname: "",
        groupCreateName: "",
        sortNum: "",
      },
      // 表格选择项
      multipleSelection: [],
      // 存储操作后需要手动刷新的数据，element树形表格存在按钮删除或更新子表格时没有自动更新数据的bug
      map: new Map(),
      Permission: [],
    };
  },
  mounted() {
    this.queryKeyword();
    this.Permission = getPermission();
  },
  filters: {
    // 使用moment格式化时间
    formateDate(date) {
      if (date) {
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
  },
  methods: {
    queryKeyword() {
      let params = {
        current: this.offset,
        size: this.limit,
        groupName: this.seek.groupName ? this.seek.groupName : undefined,
        groupMonitorType: this.seek.selectType
          ? this.seek.selectType
          : undefined,
        cname: this.seek.cname ? this.seek.cname : undefined,
        groupCreateName: this.seek.groupCreateName
          ? this.seek.groupCreateName
          : undefined,
        sortNum: this.seek.sortNum ? this.seek.sortNum : undefined,
      };
      queryGroup(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.projectList = data.records;
          this.total = data.total;
          this.projectList.unshift({});
        }
      });
    },
    // 排序
    sortChange({ column, prop }) {
      if (prop == "groupName") {
        if (column.order == "descending") {
          this.seek.sortNum = 2;
        } else {
          this.seek.sortNum = 1;
        }
      } else if (prop == "cname") {
        if (column.order == "descending") {
          this.seek.sortNum = 4;
        } else {
          this.seek.sortNum = 3;
        }
      } else if (prop == "groupCreateName") {
        if (column.order == "descending") {
          this.seek.sortNum = 6;
        } else {
          this.seek.sortNum = 5;
        }
      } else if (prop == "groupCreate") {
        if (column.order == "descending") {
          this.seek.sortNum = 8;
        } else {
          this.seek.sortNum = 7;
        }
      } else {
        this.seek.sortNum = "";
      }
    },
    // 弹出项目选择框进行选择添加项目
    selectProject() {
      this.$refs.contDialog.show();
    },
    // 懒加载表格数据
    load(tree, treeNode, resovle) {
      // 把当前树的分组Id作为父id
      this.map.set(tree.groupId, { tree, treeNode, resovle });
      getSecondGroup(tree.groupId).then((res) => {
        if (res.data.code === 0) {
          resovle(res.data.data);
        }
      });
    },
    //禁止第一行搜索栏选中
    checkboxInit(row, index) {
      if (index == 0) {
        return 0;
      } else {
        return 1;
      }
    },
    selectChange(val) {
      this.multipleSelection = val;
      // 快速接入添加设备使用到了项目列表模块，把选择数据返回给快速接入添加设备模块
      this.$emit("getSelections", this.multipleSelection);
    },
    // 编辑项目
    editProject(item) {
      this.$refs.contDialog.show(item);
    },
    // 添加项目
    addProject() {
      this.$refs.contDialog.show();
    },
    // 删除项目
    deleteProject(row) {
      this.$confirm(this.$t('lang.projectList.confirmdeletion'), `${this.$t("lang.Button.tips")}`, {
        confirmButtonText: `${this.$t("lang.Button.confirm")}`,
        cancelButtonText: `${this.$t("lang.Button.cancel")}`,
        type: "warning",
        center: true,
      }).then(() => {
        // 删除
        deleteProjectGroup(row.groupId)
          .then((res) => {
            if (res.data.code === 0) {
              this.$message.success(
                `${this.$t("lang.Confirm.SuccessfullyDelete")}`
              );
              this.offset = 1;
              this.queryKeyword();
              // 获取map中与删除数据对应的数据
              this.reFleshTable(row.groupPid);
            } else if (res.data.code == 47) {
              this.$message.error(this.$t("lang.projectList.cannotbedeleted"));
            } else {
              this.$message.error(`${this.$t("lang.Confirm.DeleteFailed")}`);
            }
          })
          .catch(() => {});
      });
    },
    // 点击详情跳转到设备列表页
    goToDevices(row) {
      this.$store.dispatch("setGroup", row);
      this.$router.push({
        path: `/cloudMonitor/deviceManagement/deviceList`,
      });
    },

    // 编辑、添加子分组手动刷新表格
    reFleshTable(goupId) {
      // 在哪个分组下添加
      const { tree, treeNode, resovle } = this.map.get(goupId);
      this.load(tree, treeNode, resovle);
    },
  },
};
</script>
<style scoped>
.table-font {
  font-size: 0.25rem;
}
</style>
